import type { AccessibilityToggleTranslations } from "./pl";

export const en: AccessibilityToggleTranslations = {
  triggerAria: "Open digital accessibility panel",
  triggerTitle: "Digital accessibility",
  dialogAria: "Digital accessibility panel",
  panelTitle: "Digital accessibility",
  closeAria: "Close accessibility panel",
  fontSize: {
    heading: "Font size",
    sliderAria: "Font size",
    small: "Small",
    large: "Large",
  },
  contrast: {
    heading: "Contrast",
    label: "High contrast",
  },
  navigation: {
    heading: "Navigation",
    highlightLinks: "Highlight links",
  },
  shortcuts: {
    heading: "Keyboard shortcuts",
    jumpToContent: "Jump to content",
    jumpToMenu: "Jump to menu",
  },
  reset: "Restore defaults",
};
